export default class ResultSetWithCountDTO<T> {
    public success!: boolean;
    public resultSet!: Array<T>;
    public totalMatchedRecords!: number;

    constructor(init ?: Partial<ResultSetWithCountDTO<T>>) {
        Object.assign(this, init);
    }
}